import React from 'react';
import Milestone from '@mui/icons-material/StopOutlined';

const OutlinedMilestoneIcon = ({ style, ...rest }: { style?: React.CSSProperties }) => (
  <Milestone style={{ transform: 'rotate(45deg)', ...style }} {...rest} />
);

export default OutlinedMilestoneIcon;
